// extracted by mini-css-extract-plugin
module.exports = {"preloader":"preloader--2WOhL","ball-scale-multiple":"ball-scale-multiple--1Jelx","ballScaleMultiple":"ball-scale-multiple--1Jelx"};